import styled from 'styled-components';
export const $Container = styled.div `
  padding: ${({ theme }) => `${theme.spacing(1)} 0`};
`;
export const $SectionTitle = styled.h3 `
  margin: 0 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme, error }) => error && theme.colors.feedback.error};
`;
export const $DocumentList = styled.ul `
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
  list-style: none;
  margin: ${({ theme }) => theme.spacing(1)} 0 0;
  padding: 0;
`;
export const $DocumentItem = styled.li `
  margin: 0;
  min-width: 0;
`;
export const $DocumentLink = styled.a `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  max-width: 260px;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(1)}`};
  border: 1px solid ${({ theme }) => theme.colors.cards.border};
  border-radius: ${({ theme }) => theme.dimensions.borderRadius};
  background: ${({ theme }) => theme.colors.cards.background};
  color: ${({ theme }) => theme.colors.text.title};
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease, box-shadow 0.15s ease;
  &:hover {
    background: ${({ theme }) => theme.colors.cards.backgroundDarker};
    ${({ theme }) => theme.elevations[0]};
  }
`;
export const $Thumb = styled.span `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.dimensions.borderRadius};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
`;
export const $ThumbImage = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const $ExtBadge = styled.span `
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 90%;
  padding: 0 2px;
  border-radius: 2px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  font-size: 8px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.4;
  letter-spacing: 0.3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const $FileName = styled.span `
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
`;
export const $Empty = styled.p `
  margin: ${({ theme }) => theme.spacing(1)} 0;
  color: ${({ theme }) => theme.colors.greyScales[800]};
`;
